import useFetchEffect from '@/hooks/useFetchEffect';
import {
  fetchNotifications,
  fetchPropertiesDocumentStatistics,
  fetchPropertiesValueEstimates,
  getPropertyPriceHistories,
} from '@/api/properties';
import { fetchPropertyCompanyStats } from '@/api/propertyowners';
import { connect } from 'react-redux';
import { acSetUserNotifications } from '@/store/actions/notifications';
import { sGetUserNotifications } from '@/store/reducers/notifications';
import {
  acSetPropertyCompanyStats,
  acSetPropertyDocumentStatistics,
  acSetPropertyValueEstimates,
  acSetPropertyValueIncreases,
} from '@/store/actions/properties';
import {
  sGetPropertyByBoligmappaNumber,
  sGetPropertyCompanyStats,
  sGetPropertyDocumentStatistics,
  sGetPropertyValueEstimates,
  sGetPropertyValueIncreases,
} from '@/store/reducers/properties';
import { useFetchDocuments } from '@/api/hooks';

const PropertyDataProvider = ({
  children,
  boligmappaNumber,
  userNotifications,
  propertyValueIncreases,
  propertyValueEstimates,
  propertyDocumentStatistics,
  propertyCompanyStats,
  getPropertyByBoligmappaNumber,
  setPropertyValueIncreases,
  setPropertyValueEstimates,
  setPropertyDocumentStatistics,
  setPropertyCompanyStats,
  setUserNotifications,
}) => {
  useFetchDocuments(getPropertyByBoligmappaNumber(boligmappaNumber));

  useFetchEffect({
    // setFetchingFunction: setPropertyCompanyStatsFetching,
    onSuccess: (data) => setUserNotifications(data.notifications),
    conditionFunction: () => !userNotifications,
    apiFetchFunction: () => fetchNotifications(),
  });

  useFetchEffect({
    // setFetchingFunction: setPropertyCompanyStatsFetching,
    onSuccess: (data) => setPropertyValueIncreases(data),
    conditionFunction: () => !propertyValueIncreases,
    apiFetchFunction: () => getPropertyPriceHistories(),
  });

  useFetchEffect({
    // setFetchingFunction: setPropertyCompanyStatsFetching,
    onSuccess: (data) => setPropertyValueEstimates(data),
    conditionFunction: () => !propertyValueEstimates,
    apiFetchFunction: () => fetchPropertiesValueEstimates(),
  });

  useFetchEffect({
    // setFetchingFunction: setPropertyCompanyStatsFetching,
    onSuccess: (data) => setPropertyDocumentStatistics(data),
    conditionFunction: () => !propertyDocumentStatistics,
    apiFetchFunction: () => fetchPropertiesDocumentStatistics(),
  });

  useFetchEffect({
    // setFetchingFunction: setPropertyCompanyStatsFetching,
    onSuccess: (data) => setPropertyCompanyStats(data),
    conditionFunction: () => !propertyCompanyStats,
    apiFetchFunction: () => fetchPropertyCompanyStats(),
  });
  return children;
};

const mapStateToProps = (state) => ({
  userNotifications: sGetUserNotifications(state),
  propertyValueIncreases: sGetPropertyValueIncreases(state),
  propertyValueEstimates: sGetPropertyValueEstimates(state),
  propertyDocumentStatistics: sGetPropertyDocumentStatistics(state),
  propertyCompanyStats: sGetPropertyCompanyStats(state),
  getPropertyByBoligmappaNumber: (boligmappaNumber) =>
    sGetPropertyByBoligmappaNumber(state, boligmappaNumber),
});
const mapDispatchToProps = (dispatch) => ({
  setUserNotifications: (data) => dispatch(acSetUserNotifications(data)),
  setPropertyValueIncreases: (data) =>
    dispatch(acSetPropertyValueIncreases(data)),
  setPropertyValueEstimates: (data) =>
    dispatch(acSetPropertyValueEstimates(data)),
  setPropertyDocumentStatistics: (data) =>
    dispatch(acSetPropertyDocumentStatistics(data)),
  setPropertyCompanyStats: (data) => dispatch(acSetPropertyCompanyStats(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertyDataProvider);
